import { connect } from 'react-redux'

import ReportLink from './report_link'

const mapStateToProps = (state, props) => {
  return {
    currentUserCountryCode: state.country.country_code,
  }
}

export default connect(mapStateToProps)(ReportLink)
